"use client";
import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { PenLine, FileText, BadgeCheck, Globe, TrendingUp, PenTool, FileEdit, Network, ClipboardList, Megaphone } from "lucide-react";
import "../../scss/_partner-with-us.scss";
import partnerTogether from "../../../public/icons/partnerTogether.png";
import handshake from "../../../public/business_handshake_professional_1773314847717.png";
import papers from "../../../public/signing_financial_papers_1773314672363.png";
import chart from "../../../public/stock_market_chart_neon_1773314824297.png";
import cocaColaLogo from "../../../public/icons/Cocacola - Copy.png";
import airbnbLogo from "../../../public/icons/AirbnbLogo.svg - Copy.png";
import googleLogo from "../../../public/icons/GoogleLogo - Copy.png";
import stripeLogo from "../../../public/icons/Stripe - Copy.png";
import expediaLogo from "../../../public/icons/ExpediaLogo.svg - Copy.png";
import insightsIcon from "../../../public/icons/insightsdash.png";
import carbonIcon from "../../../public/icons/carbondash.png";
import bogtLogo from "../../../public/icons/BogtLogo.png";
import oepLogo from "../../../public/icons/OepLogo.png";
import scotiaBankLogo from "../../../public/icons/ScotiaBank.png";
import sponsoredContentIcon from "../../../public/icons/ri_draft-line.png";
import categorySponsorshipIcon from "../../../public/icons/material-symbols_category-search-outline.png";
import newsletterIcon from "../../../public/icons/quill_inbox-newsletter.png";
import industryCampaignIcon from "../../../public/icons/material-symbols_campaign-outline.png";

const whyChooseCards = [
  {
    title: "An Audience That's Already Engaged",
    description:
      "Our readers already come to Invest in Energy to learn about oil, gas, and energy investing. Your brand appears in front of an audience that is actively seeking relevant information.",
  },
  {
    title: "Industry-Specific Content Ecosystem",
    description:
      "Articles, market insights, news, and resources all live in one place, giving your content context alongside trusted energy education.",
  },
  {
    title: "Search-First Visibility",
    description:
      "Every article, press release, and profile is structured for discoverability so the content keeps working long after publication.",
  },
  {
    title: "Long-Term Discoverability",
    description:
      "Your content stays accessible through search, category pages, and internal linking, helping it earn attention over time.",
  },
  {
    title: "Investor and Executive Readership",
    description:
      "Our audience includes investors, executives, operators, and professionals who care about practical energy insights.",
  },
  {
    title: "A Dedicated Company Profile",
    description:
      "Create a branded home on the platform where investors and partners can learn about your company and connect with your team.",
  },
];

const stats = [
  {
    title: "Expansive Global Audience related to niche",
    icon: <Globe size={40} />,
  },
  {
    title: "Thousands of Monthly Website Visitors",
    icon: <Image src={insightsIcon} alt="Insights" width={40} height={40} />,
  },
  {
    title: "Hundreds of Articles Published",
    icon: <Image src={carbonIcon} alt="Carbon" width={40} height={40} />,
  },
];

const flagCodes = {
  "United States": "us",
  "United Kingdom": "gb",
  "Netherlands": "nl",
  "Brazil": "br",
  "Denmark": "dk",
};

const geography = ["United States", "Brazil", "United Kingdom", "Denmark", "Netherlands"];

const sectors = [
  "Financial Services",
  "Private Equity & Investment Firms",
  "Family Offices",
  "Oil & Gas Industry",
  "Energy Services",
  "Real Estate Investors",
  "Legal & Tax Services",
  "Institutional Investors",
  "Corporate Executives & Business Owners",
  "Banking & Commercial Finance",
  "Engineering & Technical Consulting",
];

const partnerCards = [
  {
    name: "Blue Ocean Global Technology",
    tag: "Tech & IT",
    description: "BOGT delivers reliable IT services and solutions through trusted expertise and strong partnerships.",
    articles: "12 Articles",
    authors: "4 Authors",
    logo: bogtLogo,
  },
  {
    name: "Optimum Energy Partners",
    tag: "Oil & Gas",
    description: "Gulf delivers reliable oil and gas solutions through trusted expertise and strong partnerships.",
    articles: "12 Articles",
    authors: "4 Authors",
    logo: oepLogo,
  },
  {
    name: "Blue Ocean Global Technology",
    tag: "Tech & IT",
    description: "BOGT delivers reliable IT services and solutions through trusted expertise and strong partnerships.",
    articles: "12 Articles",
    authors: "4 Authors",
    logo: bogtLogo,
  },
  {
    name: "Blue Ocean Global Technology",
    tag: "Tech & IT",
    description: "BOGT delivers reliable IT services and solutions through trusted expertise and strong partnerships.",
    articles: "12 Articles",
    authors: "4 Authors",
    logo: bogtLogo,
  },
  {
    name: "Optimum Energy Partners",
    tag: "Oil & Gas",
    description: "Gulf delivers reliable oil and gas solutions through trusted expertise and strong partnerships.",
    articles: "12 Articles",
    authors: "4 Authors",
    logo: oepLogo,
  },
  {
    name: "Optimum Energy Partners",
    tag: "Oil & Gas",
    description: "Gulf delivers reliable oil and gas solutions through trusted expertise and strong partnerships.",
    articles: "12 Articles",
    authors: "4 Authors",
    logo: oepLogo,
  },
];

const submissionSteps = [
  "Authors submit articles through the Author Dashboard.",
  "All articles must go through editorial verification before publication.",
  "Add comments for revision.",
  "Authors are notified of editorial decisions and can revise articles accordingly.",
  "Once approved, articles are published in the Blogs page of the site.",
];

const stepColors = ["#BECEE9", "#9CB4DB", "#7897CD", "#567CBF", "#2E5EB0"];

const stepPaths = [
  "M0.848722 5.00586C-0.88745 3.07498 0.482883 0 3.07954 0H128.044C128.876 0 129.67 0.34514 130.237 0.953045L183.437 57.953C184.513 59.1057 184.513 60.8943 183.437 62.047L130.237 119.047C129.67 119.655 128.876 120 128.044 120H3.00528C0.420375 120 -0.954411 116.949 0.757932 115.013L48.0756 61.504C49.0854 60.362 49.0783 58.6443 48.059 57.5108L0.848722 5.00586Z",
  "M0.848722 5.00586C-0.88745 3.07498 0.482883 0 3.07954 0H128.044C128.876 0 129.67 0.34514 130.237 0.953045L183.437 57.953C184.513 59.1057 184.513 60.8943 183.437 62.047L130.237 119.047C129.67 119.655 128.876 120 128.044 120H3.00528C0.420375 120 -0.954411 116.949 0.757932 115.013L48.0756 61.504C49.0854 60.362 49.0783 58.6443 48.059 57.5108L0.848722 5.00586Z",
  "M0.848722 5.00586C-0.88745 3.07498 0.482883 0 3.07954 0H128.044C128.876 0 129.67 0.34514 130.237 0.953045L183.437 57.953C184.513 59.1057 184.513 60.8943 183.437 62.047L130.237 119.047C129.67 119.655 128.876 120 128.044 120H3.00528C0.420375 120 -0.954411 116.949 0.757932 115.013L48.0756 61.504C49.0854 60.362 49.0783 58.6443 48.059 57.5108L0.848722 5.00586Z",
  "M0.848722 5.00586C-0.88745 3.07498 0.482883 0 3.07954 0H128.044C128.876 0 129.67 0.34514 130.237 0.953045L183.437 57.953C184.513 59.1057 184.513 60.8943 183.437 62.047L130.237 119.047C129.67 119.655 128.876 120 128.044 120H3.00528C0.420375 120 -0.954411 116.949 0.757932 115.013L48.0756 61.504C49.0854 60.362 49.0783 58.6443 48.059 57.5108L0.848722 5.00586Z",
  "M0.848722 5.00586C-0.88745 3.07498 0.482883 0 3.07954 0H128.044C128.876 0 129.67 0.34514 130.237 0.953045L183.437 57.953C184.513 59.1057 184.513 60.8943 183.437 62.047L130.237 119.047C129.67 119.655 128.876 120 128.044 120H3.00528C0.420375 120 -0.954411 116.949 0.757932 115.013L48.0756 61.504C49.0854 60.362 49.0783 58.6443 48.059 57.5108L0.848722 5.00586Z",
];

const seoBenefits = [
  "All published content is indexed by Google and other major search engines",
  "Industry-specific keyword targeting aligned with energy investment search intent",
  "Backlinks from your published content pointing to your company website",
  "Evergreen discoverability : your content keeps ranking long after publication",
  "Branded search presence through your company profile and author pages",
];

const distributionChannels = [
  "Search Engines : Google, Bing, and others",
  "Newsletter : distributed to our subscriber base",
  "Social Media : amplified across our channels",
  "Category Hubs : surfaced in relevant topic sections on the platform",
  "Company Profile Pages : all content linked to your branded profile",
  "RSS Syndication",
];

const topics = [
  {
    title: "Oil & Gas Fundamentals",
    items: [
      "Basics of oil and gas investing",
      "Understanding exploration, production, and royalties",
      "Midstream and downstream operations explained",
      "Crude oil pricing and benchmarks",
    ],
  },
  {
    title: "Energy Markets & Economics",
    items: [
      "Global supply and demand dynamics",
      "Geopolitics and its influence on energy markets",
      "Commodity trading, futures, and hedging strategies",
      "OPEC policies and international energy cooperation",
    ],
  },
  {
    title: "Investment Strategies",
    items: [
      "Portfolio diversification through energy assets",
      "Direct participation programs",
      "Private equity and institutional investing in energy",
      "Risk management and return optimization",
    ],
  },
  {
    title: "Energy Transition & Innovation",
    items: [
      "Renewable integration and hybrid portfolios",
      "Carbon capture and storage technologies",
      "Digital transformation and AI in oilfield operations",
      "Emerging trends in energy, tech, and sustainability",
    ],
  },
  {
    title: "Policy, ESG, and Sustainability",
    items: [
      "ESG reporting standards in oil and gas",
      "Environmental regulations and compliance",
      "The role of investors in the global energy transition",
      "Ethical considerations in fossil fuel investment",
    ],
  },
  {
    title: "Leadership & Expert Insight",
    items: [
      "Market outlooks and economic forecasts",
      "Case studies of successful investments",
      "Interviews with industry leaders",
      "Leadership, mentorship, and diversity in energy",
    ],
  },
];

const extraWays = [
  {
    title: "Sponsored Content",
    description:
      "Work with our editorial team to produce in-depth sponsored articles or guides that carry your brand while delivering genuine value to our readers.",
    icon: <Image src={sponsoredContentIcon} alt="Sponsored Content" width={48} height={48} style={{ width: "48px", height: "48px", objectFit: "contain" }} />,
  },
  {
    title: "Category Sponsorships",
    description:
      "Sponsor a specific content category on the platform, such as Oil & Gas, Renewables, or Energy Technology, and receive premium placement across all content in that section.",
    icon: <Image src={categorySponsorshipIcon} alt="Category Sponsorships" width={48} height={48} style={{ width: "48px", height: "48px", objectFit: "contain" }} />,
  },
  {
    title: "Newsletter Sponsorships",
    description:
      "Reach our subscriber base directly with a dedicated mention or sponsored section in our weekly energy investment newsletter.",
    icon: <Image src={newsletterIcon} alt="Newsletter Sponsorships" width={48} height={48} style={{ width: "48px", height: "48px", objectFit: "contain" }} />,
  },
  {
    title: "Industry Campaigns",
    description:
      "Design a multi-channel campaign with content, social promotion, and newsletter features, tailored to your company's goals and target audience.",
    icon: <Image src={industryCampaignIcon} alt="Industry Campaigns" width={48} height={48} style={{ width: "48px", height: "48px", objectFit: "contain" }} />,
  },
];

const faqs = [
  {
    question: "How long does it take for my content to be published after submission?",
    answer:
      "Most submissions are reviewed within 10-20 business days. You will receive an email notification once your content is approved and live on the platform. Submissions that require edits will be returned to you with feedback before they go through a second review.",
  },
  {
    question: "Can I update or edit content after it has been published?",
    answer:
      "Yes. Minor corrections and factual updates can be requested through your account dashboard or by contacting our team. Significant edits may require a secondary editorial review before the updated version goes live.",
  },
  {
    question: "How do I manage my company profile?",
    answer:
      "Your company profile can be updated at any time through your account dashboard. You can edit your company bio, update your logo, and manage published content.",
  },
  {
    question: "What's the difference between a press release and an article?",
    answer:
      "A press release is a formal announcement of company news, such as funding rounds, product launches, partnerships, and operational updates. An article is longer-form, educational content authored by your team, designed to provide value to energy investors on topics relevant to the sector.",
  },
  {
    question: "Which partnership plan is right for my company?",
    answer:
      "That depends on the volume of content you want to publish, the visibility you're looking for, and whether you want access to distribution and analytics features. We recommend starting with the plan that matches your current content output and scaling from there. If you're unsure, contact us and we'll help you choose.",
  },
  {
    question: "Can I track how my content is performing?",
    answer:
      "Yes. All partnership plans include some level of performance reporting. Professional and Enterprise partners have access to more detailed analytics, including content views, audience engagement, and reach across our distribution channels.",
  },
  {
    question: "Who owns the content I publish on Invest in Energy?",
    answer:
      "You retain ownership of all content you submit. By publishing on Invest in Energy, you grant us a non-exclusive license to display, distribute, and promote that content on our platform and through our channels. See our Content Ownership policy in the Compliance section for full details.",
  },
  {
    question: "Is Invest in Energy open to companies in all countries?",
    answer:
      "Yes. Invest in Energy welcomes partner companies from across the global energy sector. Our readership spans multiple countries, and we accept content covering global energy markets and developments.",
  },
];

const readingAudience = [
  "Retail Investors",
  "Accredited & High-Net-Worth Investors",
  "Financial Advisors & Wealth Managers",
  "Energy Industry Professionals",
  "Business Owners & Entrepreneurs",
  "Family Offices & Private Capital",
  "Students & Curious Learners",
];

function SectionTitle({ kicker, title, description, align = "left", light = false }) {
  return (
    <div className={`pwu-section-heading ${align === "center" ? "is-centered" : ""} ${light ? "is-light" : ""}`}>
      {kicker ? <span className="pwu-kicker">{kicker}</span> : null}
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </div>
  );
}

function IconBadge({ icon }) {
  return <span className="pwu-icon-badge" aria-hidden="true">{icon}</span>;
}

function ChecklistItem({ children }) {
  return (
    <li className="pwu-check-item">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="pwu-check-icon-svg" aria-hidden="true">
        <circle cx="10" cy="10" r="10" fill="#0D2469" />
        <path d="M6 10L9 13L14 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span>{children}</span>
    </li>
  );
}

export default function PartnerWithUsPage() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
    {
      quote: "“Invest in Energy gave us more than visibility. It helped us connect with people who already understood the value of long term energy investment. The conversations were focused, practical, and far more productive than what we had seen through other channels.”",
      author: "Rachel Adams, Director of Business Development,",
      company: "Horizon Energy Partners",
      brand: "scotiabank",
      logo: scotiaBankLogo,
    },
    {
      quote: "“Publishing on Invest in Energy isn't just about branding; it's about building authority. Our articles consistently rank for key search intents, driving qualified leads from institutional investors that we couldn't reach elsewhere.”",
      author: "Marcus Vance, Head of Investor Relations,",
      company: "Vance Energy Holdings",
      brand: "apex",
    }
  ];

  const handlePrevTestimonial = () => {
    setActiveTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const handleNextTestimonial = () => {
    setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const currentTestimonial = testimonials[activeTestimonial];
  return (
    <div className="partner-with-us-page">
      <section className="pwu-hero-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="pwu-hero-content">
                <span className="pwu-hero-label">Partner With Us</span>
                <h1 className="pwu-hero-title">
                  Reach the Investors, Executives, and Professionals Driving the Energy Sector
                </h1>
                <p className="pwu-hero-text">
                  Invest in Energy is a nonprofit, educational platform built for oil and gas investors and the companies that serve them. We give energy companies a trusted space to publish press releases, share expert insights, and build a lasting digital presence in front of an audience that is already looking for exactly what you offer.
                </p>
                <div className="pwu-hero-buttons">
                  <a href="#partner-contact" className="pwu-btn pwu-btn-solid">
                    Become A Partner
                  </a>
                  <Link href="/partner-with-us/create-company-profile" className="pwu-btn pwu-btn-outline">
                    Create Your Company Profile
                  </Link>
                </div>
              </div>
              <div className="pwu-hero-image-wrapper">
                <Image
                  src={partnerTogether}
                  alt="Invest in Energy partner showcase"
                  className="pwu-hero-image"
                  fill
                  priority
                  style={{ objectFit: "cover" }}
                  sizes="(max-width: 992px) 100vw, 1263px"
                />
              </div>
              <div className="pwu-image-footer">
                <div className="pwu-footer-dots">
                  <span className="pwu-dot active" />
                  <span className="pwu-dot" />
                  <span className="pwu-dot" />
                </div>
                <a
                  href="https://blueoceanglobaltech.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pwu-explore-btn"
                >
                  Explore Partner Website
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pwu-section pwu-white-section pwu-why-section">
        <div className="wrapper-container">
          <SectionTitle
            align="center"
            title="Why Energy Companies Choose Invest in Energy"
            description="We built this platform for energy investors. That means every reader, subscriber, and visitor is already interested in the sector you operate in. Partnering with Invest in Energy puts your brand directly in front of the people who matter most to your business."
          />

          <div className="pwu-card-grid">
            {whyChooseCards.map((card) => (
              <article key={card.title} className="pwu-info-card">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </article>
            ))}
          </div>

          <div className="pwu-section-cta">
            <a href="#partner-ways" className="pwu-explore-btn">
              Explore Partnership Opportunities
            </a>
          </div>
        </div>
      </section>

      <section className="pwu-section pwu-reading-section">
        <div className="wrapper-container">
          <div className="row pwu-reading-row">
            <div className="col-lg-4">
              <div className="pwu-image-frame">
                <Image
                  src={chart}
                  alt="Readers evaluating market data"
                  fill
                  sizes="(max-width: 992px) 100vw, 33vw"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-8">
              <SectionTitle
                title="Who's Reading Our Platform"
                description="Our audience is made up of professionals across the full energy investment value chain — from first-time investors exploring the sector to industry veterans making major capital decisions."
              />
              <div className="pwu-audience-columns">
                <ul>
                  {readingAudience.slice(0, 4).map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                <ul>
                  {readingAudience.slice(4).map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <p className="pwu-audience-bottom-text">
                When you publish on Invest in Energy, your content reaches people who have already made the decision to educate themselves about energy investing. That intent matters.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="company-profile" className="pwu-section pwu-profile-section">
        <div className="wrapper-container">
          <div className="row align-items-center g-4">
            <div className="col-lg-4">
              <div className="pwu-company-copy">
                <h2>Build Your Company Profile</h2>
                <p>
                  Your company profile is your branded home on the Invest in Energy platform. It&apos;s where investors, partners, and potential clients can find your team, read your published content, and get a clear picture of who you are and what you do.
                </p>
                <a href="#partner-contact" className="pwu-explore-btn">
                  Create Your Company Profile
                </a>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="pwu-profile-image-frame">
                <Image
                  src={papers}
                  alt="Company profile dashboard preview"
                  fill
                  sizes="(max-width: 992px) 100vw, 50vw"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
          </div>

          <div className="pwu-brand-row-container">
            <div className="pwu-brand-row">
              <span className="pwu-brand-title">Our Growing team</span>
              <Image src={cocaColaLogo} alt="Coca-Cola" className="pwu-brand-logo" />
              <Image src={airbnbLogo} alt="Airbnb" className="pwu-brand-logo" />
              <Image src={googleLogo} alt="Google" className="pwu-brand-logo" />
              <Image src={stripeLogo} alt="Stripe" className="pwu-brand-logo" />
              <Image src={expediaLogo} alt="Expedia" className="pwu-brand-logo" />
            </div>
          </div>

          <div className="pwu-setup-container">
            <h2 className="pwu-setup-title">How to Set Up Your Profile</h2>
            <div className="row g-4 pwu-setup-grid">
              <div className="col-lg-4">
                <div className="pwu-setup-card">
                  <div className="pwu-setup-header">
                    <div className="pwu-setup-icon-box">
                      <PenLine size={20} />
                    </div>
                    <h3>Application</h3>
                  </div>
                  <p>
                    Prospective authors can apply through the “Become an Author” form by providing their name, email, a brief introduction, writing interests, publication links, and social media profiles.
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="pwu-setup-card">
                  <div className="pwu-setup-header">
                    <div className="pwu-setup-icon-box">
                      <FileText size={20} />
                    </div>
                    <h3>Review</h3>
                  </div>
                  <p>
                    The editorial team reviews each application for expertise, writing quality, experience, and alignment with Invest in Energy&apos;s values and long-term editorial contribution and impact.
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="pwu-setup-card">
                  <div className="pwu-setup-header">
                    <div className="pwu-setup-icon-box">
                      <BadgeCheck size={20} />
                    </div>
                    <h3>Approval</h3>
                  </div>
                  <p>
                    Once approved, authors can access the Author Dashboard to create, edit, and manage their content. They can also choose article topics that match their expertise and interests.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pwu-section pwu-numbers-section">
        <div className="wrapper-container">
          <div className="row align-items-start gy-4">
            <div className="col-lg-6">
              <SectionTitle
                light
                title="Our Platform, by the Numbers"
              />
            </div>
            <div className="col-lg-6">
              <p className="pwu-section-sidelabel">
                Invest in Energy is a growing hub for energy investment education and industry news.
                Here&apos;s where we stand:
              </p>
            </div>
          </div>

          <div className="row g-4 pwu-metric-row">
            {stats.map((stat) => (
              <div key={stat.title} className="col-lg-4">
                <div className="pwu-metric-card">
                  <div className="pwu-metric-icon">{stat.icon}</div>
                  <h3>{stat.title}</h3>
                </div>
              </div>
            ))}
          </div>

          <div className="row g-4 pwu-audience-row">
            <div className="col-lg-3">
              <div className="pwu-audience-block">
                <h4>Audience Geography</h4>
                <ul className="pwu-flag-list">
                  {geography.map((item) => (
                    <li key={item}>
                      <span className="pwu-flag-img-wrapper">
                        {/* eslint-disable-next-line @next/next/no-img-element */}
                        <img
                          src={`https://flagcdn.com/w20/${flagCodes[item]}.png`}
                          alt={`${item} flag`}
                          width="20"
                          height="15"
                          style={{ objectFit: "contain", borderRadius: "2px" }}
                        />
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="pwu-audience-block">
                <h4>Audience by Sector</h4>
                <ul className="pwu-sector-list">
                  {sectors.map((item) => (
                    <li key={item}>
                      <span className="pwu-sector-dot" aria-hidden="true" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pwu-section pwu-white-section pwu-partners-section">
        <div className="wrapper-container">
          <SectionTitle
            title="Meet our Partners"
            description="We collaborate with trusted oil and gas professionals who bring deep industry knowledge, operational experience, and a shared commitment to responsible energy development. Together, we create stronger opportunities, support informed decisions, and deliver long term value across every stage of the energy sector."
          />

          <div className="row g-4">
            {partnerCards.map((card, idx) => (
              <div key={`${card.name}-${idx}`} className="col-lg-4 col-md-6">
                <article className="pwu-partner-card">
                  <div className="pwu-partner-head">
                    <Image src={card.logo || partnerTogether} alt={`${card.name} logo`} className="pwu-partner-logo" width={40} height={40} />
                    <div>
                      <h3>{card.name}</h3>
                      <span>{card.tag}</span>
                    </div>
                  </div>
                  <p>{card.description}</p>
                  <div className="pwu-partner-foot">
                    <span>
                      {card.articles}&nbsp;&nbsp;|&nbsp;&nbsp;{card.authors}
                    </span>
                    <a href="#partner-contact">View Profile &rsaquo;</a>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pwu-section pwu-light-section pwu-publish-section">
        <div className="wrapper-container">
          <SectionTitle
            title="Publish Press Releases & Articles"
          />

          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div className="pwu-publish-copy">
                <h3>Share Your Story with the Energy Investment Community</h3>
                <p>
                  Invest in Energy accepts two types of partner content: press releases and articles. Both are
                  reviewed by our editorial team and published directly on the platform, where they&apos;re
                  indexed by search engines and promoted across our distribution channels.
                </p>
                <h4>Press Releases</h4>
                <p>
                  Use press releases to share company news, product launches, funding announcements, new
                  partnerships, industry milestones, and operational updates. Press releases on Invest in Energy are
                  published with attribution to your company profile and distributed to our audience through our
                  newsletter and social channels.
                </p>
                <h4>Articles</h4>
                <p>
                  Articles are longer-form, educational content written by your team members. They&apos;re an
                  opportunity to establish your company&apos;s voice as a trusted resource for energy investors, covering
                  topics like market trends, investment strategies, sector analysis, or technical insights. Articles are
                  attributed to your team&apos;s author profiles.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="pwu-image-frame pwu-publish-image-frame">
                <Image
                  src={papers}
                  alt="Publishing press releases and articles"
                  fill
                  sizes="(max-width: 992px) 100vw, 50vw"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pwu-section pwu-light-section pwu-submission-section">
        <div className="wrapper-container">
          <SectionTitle
            align="center"
            title="How Submission Works"
          />
          <div className="pwu-submission-grid">
            {/* Row 1: Top Descriptions */}
            {submissionSteps.map((step, index) => {
              const stepNum = index + 1;
              const isEven = stepNum % 2 === 0;
              return (
                <div key={`top-${index}`} className="pwu-grid-cell top-row">
                  {isEven ? (
                    <p className="pwu-step-description">{step}</p>
                  ) : (
                    <div className="pwu-empty-cell" />
                  )}
                </div>
              );
            })}

            {/* Row 2: Arrow Steps */}
            {submissionSteps.map((step, index) => {
              const isDarkText = index < 2;
              return (
                <div key={`arrow-${index}`} className="pwu-grid-cell arrow-row">
                  <div className="pwu-submission-step">
                    <svg viewBox="0 0 185 120" className="pwu-step-svg" fill="none">
                      <path d={stepPaths[index]} fill={stepColors[index]} />
                    </svg>
                    <span className={`pwu-step-number ${isDarkText ? "is-dark" : "is-light"}`}>
                      Step {index + 1}
                    </span>
                  </div>
                </div>
              );
            })}

            {/* Row 3: Bottom Descriptions */}
            {submissionSteps.map((step, index) => {
              const stepNum = index + 1;
              const isEven = stepNum % 2 === 0;
              return (
                <div key={`bottom-${index}`} className="pwu-grid-cell bottom-row">
                  {!isEven ? (
                    <p className="pwu-step-description">{step}</p>
                  ) : (
                    <div className="pwu-empty-cell" />
                  )}
                </div>
              );
            })}
          </div>


          <div className="pwu-submission-actions">
            <a href="#partner-contact" className="pwu-btn pwu-btn-solid">
              Submit a Press Release
            </a>
            <a href="#partner-contact" className="pwu-btn pwu-btn-outline">
              Contribute an Article
            </a>
          </div>
        </div>
      </section>

      <section className="pwu-section pwu-white-section">
        <div className="wrapper-container">
          <SectionTitle
            title="Content That Works Long After It's Published"
            description="Publishing on Invest in Energy isn't just about reaching today's readers. It's about building a content footprint in the energy investment space that grows over time."
          />

          <div className="row g-4">
            <div className="col-lg-6">
              <div className="pwu-content-panel">
                <h3>SEO Benefits</h3>
                <ul>
                  {seoBenefits.map((item) => (
                    <ChecklistItem key={item}>{item}</ChecklistItem>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="pwu-content-panel">
                <h3>Distribution Channels</h3>
                <ul>
                  {distributionChannels.map((item) => (
                    <ChecklistItem key={item}>{item}</ChecklistItem>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pwu-testimonial-section">
        <div className="wrapper-container">
          <SectionTitle
            light
            title="What Our Partners Say"
          />
          <div className="pwu-testimonial-card">
            <p className="pwu-quote">
              {currentTestimonial.quote}
            </p>
            <div className="pwu-testimonial-meta">
              <p className="pwu-author-info">
                {currentTestimonial.author}
                <br />
                {currentTestimonial.company}
              </p>
              <div className="pwu-testimonial-brand-logo">
                {currentTestimonial.logo ? (
                  <Image
                    src={currentTestimonial.logo}
                    alt={currentTestimonial.company || "Testimonial logo"}
                    height={28}
                    style={{ width: "auto", height: "28px", objectFit: "contain" }}
                  />
                ) : currentTestimonial.brand === "scotiabank" ? (
                  <Image
                    src={scotiaBankLogo}
                    alt="Scotiabank"
                    height={28}
                    style={{ width: "auto", height: "28px", objectFit: "contain" }}
                  />
                ) : (
                  <svg width="135" height="26" viewBox="0 0 135 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <polygon points="13,3 23,20 3,20" stroke="white" strokeWidth="1.8" fill="none" />
                    <text x="30" y="19" fill="white" fontFamily="Inter, system-ui, sans-serif" fontSize="15" fontWeight="700" letterSpacing="-0.5px">Apex Capital</text>
                  </svg>
                )}
              </div>
            </div>

            <div className="pwu-testimonial-nav">
              <button onClick={handlePrevTestimonial} className="pwu-nav-btn btn-up" aria-label="Previous testimonial">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 6.5L6 2L10.5 6.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <button onClick={handleNextTestimonial} className="pwu-nav-btn btn-down" aria-label="Next testimonial">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 1.5L6 6L10.5 1.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="pwu-section pwu-white-section">
        <div className="wrapper-container">
          <SectionTitle
            title="Topics We Cover"
            description="Invest in Energy publishes high-quality content across a broad spectrum of energy, finance, and sustainability-related themes. Below are our topic areas, including but not limited to:"
          />

          <div className="row g-4">
            {topics.map((topic) => (
              <div key={topic.title} className="col-lg-4 col-md-6">
                <article className="pwu-topic-card">
                  <h3>{topic.title}</h3>
                  <ul>
                    {topic.items.map((item) => (
                      <ChecklistItem key={item}>{item}</ChecklistItem>
                    ))}
                  </ul>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pwu-section pwu-white-section">
        <div className="wrapper-container">
          <SectionTitle
            align="center"
            title="Frequently Asked Questions"
          />
          <div className="pwu-faq-list">
            {faqs.map((faq) => (
              <details key={faq.question} className="pwu-faq-item">
                <summary>
                  <span>{faq.question}</span>
                  <span className="pwu-faq-toggle" aria-hidden="true">
                    +
                  </span>
                </summary>
                <div className="pwu-faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section id="partner-ways" className="pwu-extra-band">
        <div className="wrapper-container">
          <div className="row align-items-start g-4">
            <div className="col-lg-6">
              <SectionTitle
                light
                title="Additional Ways to Partner with Invest in Energy"
              />
            </div>
            <div className="col-lg-6">
              <p className="pwu-section-sidelabel pwu-section-sidelabel-light">
                Beyond our core publishing and profile packages, we offer a range of premium partnership opportunities for
                companies looking for deeper integration with our platform and audience.
              </p>
              <a href="#partner-contact" className="pwu-btn pwu-btn-soft">
                Contact Us About Premium Partnership
              </a>
            </div>
          </div>

          <div className="row g-4 pwu-extra-grid">
            {extraWays.map((item) => (
              <div key={item.title} className="col-lg-3 col-md-6">
                <article className="pwu-extra-card">
                  <IconBadge icon={item.icon} />
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="partner-contact" className="pwu-section pwu-white-section">
        <div className="wrapper-container">
          <SectionTitle
            title="Ready to Partner with Invest in Energy?"
            description={
              <>
                Whether you&apos;re ready to get started or just want to explore your options, our team is here to help.
                <br />
                Reach out and we&apos;ll get back to you within 7 business days.
              </>
            }
          />

          <div className="row g-5 align-items-stretch">
            <div className="col-lg-5">
              <div className="pwu-contact-left">
                <h3>Get in Touch</h3>
                <div className="pwu-contact-info">
                  <div className="pwu-contact-info-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="pwu-contact-icon">
                      <rect x="2" y="4" width="20" height="16" rx="2" stroke="#0d2469" strokeWidth="2" />
                      <path d="M2 7L12 13L22 7" stroke="#0d2469" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <div>
                      <span>Email</span>
                      <a href="mailto:info@investinenergy.org">info@investinenergy.org</a>
                    </div>
                  </div>
                  <div className="pwu-contact-info-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="pwu-contact-icon">
                      <circle cx="12" cy="12" r="10" stroke="#0d2469" strokeWidth="2" />
                      <path d="M2 12H22" stroke="#0d2469" strokeWidth="2" />
                      <path d="M12 2C14.5 4.5 15.5 8 15.5 12C15.5 16 14.5 19.5 12 22" stroke="#0d2469" strokeWidth="2" />
                      <path d="M12 2C9.5 4.5 8.5 8 8.5 12C8.5 16 9.5 19.5 12 22" stroke="#0d2469" strokeWidth="2" />
                    </svg>
                    <div>
                      <span>Website</span>
                      <a href="https://investinenergy.org" target="_blank" rel="noreferrer">
                        investinenergy.org
                      </a>
                    </div>
                  </div>
                </div>
                <div className="pwu-contact-image">
                  <Image
                    src={handshake}
                    alt="Business handshake"
                    fill
                    sizes="(max-width: 992px) 100vw, 34vw"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="pwu-form-panel">
                <h3>Tell Us About Your Needs</h3>
                <form className="pwu-form">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label>Full Name *</label>
                      <input type="text" placeholder="" />
                    </div>
                    <div className="col-md-6">
                      <label>Company Name *</label>
                      <input type="text" placeholder="" />
                    </div>
                    <div className="col-12">
                      <label>Email *</label>
                      <input type="email" placeholder="" />
                    </div>
                    <div className="col-12">
                      <label>Phone</label>
                      <input type="tel" placeholder="" />
                    </div>
                    <div className="col-md-6">
                      <label>Company Website *</label>
                      <input type="text" placeholder="" />
                    </div>
                    <div className="col-md-6">
                      <label>Partnership Interest *</label>
                      <select defaultValue="company-profile">
                        <option value="company-profile">Company Profile</option>
                        <option value="press-release">Press Release</option>
                        <option value="sponsorship">Sponsorship</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label>How Can We Help You? *</label>
                      <textarea rows="5" />
                    </div>
                  </div>

                  <p className="pwu-form-note">* All fields are required.</p>
                  <button type="button" className="pwu-btn pwu-btn-solid pwu-form-submit">
                    Start Your Partnership
                  </button>
                  <p className="pwu-form-privacy">
                    We respect your privacy. Your information will only be used to respond to your inquiry.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pwu-section pwu-white-section pwu-disclosure-section">
        <div className="wrapper-container">
          <SectionTitle
            title="Compliance & Disclosures"
            description="Invest in Energy is committed  to transparency, editorial integrity, and responsible publishing. The following policies govern all content published on our platform."
          />

          <div className="pwu-disclosure-grid">
            <div>
              <h3>Editorial Policy</h3>
              <p>
                All content published on Invest in Energy is reviewed against our editorial standards before
                publication. We do not publish content that is misleading, unsubstantiated, or intended to
                promote investments without adequate disclosure.
              </p>
            </div>
            <div>
              <h3>Sponsored Content Disclosure</h3>
              <p>
                Any content published in connection with a paid partnership or sponsorship arrangement is clearly
                labeled as sponsored or partner content so readers can easily distinguish it.
              </p>
            </div>
            <div>
              <h3>Content Ownership</h3>
              <p>
                Partners retain full ownership of the content they submit. By submitting content, partners grant
                Invest in Energy a non-exclusive, royalty-free license to publish and distribute that content for
                the duration of the partnership.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
